<template>
    <v-card :max-width="chart.maxWidth"
            :max-height="chart.maxHeight"
            class="mt-4"
            elevation="1">
        <v-sheet
                class="v-sheet--offset mx-auto"
                elevation="8"
                max-width="calc(100% - 32px)"
        >
            <v-card-text  class="chartStyles">
                {{chart.title}}
            </v-card-text>
        </v-sheet>

        <apexcharts  v-if="displayChart"
                    :width="chart.width"
                    :type="chart.type"
                    :options="chart.options"
                    :series="chart.series">
        </apexcharts>
        <div v-else style="height: 200px; text-align: center; padding-top: 80px">
            <h2>No data available</h2>
        </div>
    </v-card>
</template>

<script>
    import VueApexCharts from 'vue-apexcharts';

    export default {
        name: "chartBars",
        components:{
            apexcharts: VueApexCharts
        },
        props: {
            cWidth:{
                type: String
            },
            cOptions:{
                type: Object
            },
            cSeries:{
                type: Array
            },
            vTitle:{
                type: String
            },
            vMaxWidth: {
                type: String,
                default: '350px'
            },
            vMaxHeight: {
                type: String,
                default: '300px'
            }
        },
        data(){
            return{
                defaultOptions: {
                    chart: {
                      type: 'bar',
                        stacked: true,
                        toolbar: {
                            show: false
                        },
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                        },
                    },
                    yaxis:{
                        labels:{
                            show:false
                        }
                    },
                    xaxis: {
                        labels: {
                            show: false,
                            formatter: function (val) {
                                return val
                            }
                        },
                        axisTicks: {
                            show: false
                        },
                        axisBorder: {
                            show: false
                        }
                    },
                    tooltip: {
                        x: {
                            show: false
                        },
                        y: {
                            formatter: value => parseInt(value)
                        }
                    },
                    stroke: {
                        width: 1,
                        colors: ['#fff']
                    },
                    dataLabels: {
                        enabled: true,
                    },
                    legend: {
                        position: 'bottom',
                        horizontalAlign: 'center',
                        onItemHover: {
                            highlightDataSeries: true
                        }
                    },
                    theme: {
                        palette: 'palette6',
                        monochrome: {
                            enabled: false,
                            color: '#255aee',
                            shadeTo: 'light',
                            shadeIntensity: 0.65
                        }
                    }
                }
            }
        },
        computed:{
            displayChart() {
              return this.cSeries !== null && this.cSeries.length > 0
            },
            chart() {
                //can override default options
                Object.assign(this.defaultOptions, this.cOptions);

                return {
                    maxWidth: this.vMaxWidth,
                    maxHeight: this.vMaxHeight,
                    type: "bar",
                    title: this.vTitle.split(/(?=[A-Z])/).join(" "),
                    width: this.cWidth,
                    options: this.defaultOptions,
                    series: this.cSeries,
                }
            }
        }
    }
</script>

<style scoped>
    .chartStyles {
        background-color: #24C5D9;
        color:white;
        font-weight: bold;
        font-size: larger;
    }
</style>